module.exports = require('./dist/enigma-mocker');
